<div>
  <h2 [id]="title">
    @if (icon) {
      <i class="bi" [class]="icon"></i>
    }
    {{ title }}
  </h2>
</div>
